import { useEffect, useRef } from "react";
import Lenis from "lenis";
import { useLocation } from "react-router-dom";
import "lenis/dist/lenis.css";

const SmoothScroll = ({ children }) => {
  const lenisRef = useRef(null);
  const { pathname } = useLocation();

  // 1. Initialize Lenis (The Smooth Scroll Physics)
  useEffect(() => {
    const lenis = new Lenis({
      duration: 1.2, // The higher the value, the smoother/slower the stop
      easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)), // Studio Freight's custom easing
      direction: "vertical",
      gestureDirection: "vertical",
      smooth: true,
      smoothTouch: false, // Default false, usually better to leave native touch scroll on mobile
      touchMultiplier: 2,
    });

    lenisRef.current = lenis;

    function raf(time) {
      lenis.raf(time);
      requestAnimationFrame(raf);
    }

    requestAnimationFrame(raf);

    return () => {
      lenis.destroy();
    };
  }, []);

  // 2. Handle Scroll Reset on Route Change
  useEffect(() => {
    if (lenisRef.current) {
      // Immediate scroll to top with no duration (instant)
      lenisRef.current.scrollTo(0, { immediate: true });
    }
  }, [pathname]);

  return <>{children}</>;
};

export default SmoothScroll;
